import React from 'react'
import { Container, Typography, Link } from '@material-ui/core'
import makeStyles from './style'
import logoFates from '../images/logoFates.jpg'


export default function Sobre() {
    const {bigContainer, container, isocontainer, title, logoFatesImg, description} = makeStyles()

    return (
        <Container className={bigContainer}>
            <Container className={container}>
            <Typography gutterBottom variant='h3' component='div' className={title}>
            A melhor escolha
            </Typography>
                <Typography gutterBottom variant='h4' component='div' className={title}>
                Nossa Empresa
                </Typography>
                <Typography variant='body2' color='text.secondary' className={description}>
                M A SERVIÇOS DE USINAGEM LTDA, situada na cidade de Amparo S/P, conta com equipamentos de 
                usinagem para diversos fins, tornos mecânicos, tornos CNC, tornos automáticos, fresadoras 
                convencionais, fresadoras CNC, centros de usinagem CNC, entre outros. 
                <br />
                <br />
                Conta também com uma equipe e colaboradores experientes e gabaritados, constantemente 
                treinados e especializados em cada setor da empresa, passando por treinamentos periódicos, 
                para reciclar e absorver novas técnicas de produção e estarem sempre atualizados com as novas 
                tecnologias. 
                <br />
                <br />
                Sua capacidade de produção atende a demanda de diversos tipos de lotes segundo a 
                necessidades de seus clientes, de pequenos a grandes lotes, sempre com o mesmo padrão de qualidade.
                </Typography>
            </Container>
            <Container className={isocontainer} >
                <div>
                    <Link href="http://fates.com.br/">
                    <img src={logoFates} className={logoFatesImg} alt='Logo Fates' />
                    </Link>
                </div>
                <Container style ={{'@media (min-width: 960px)': { marginLeft: '5vw'}}}>
                    <Typography gutterBottom variant='h4' component='div' className={title}>
                    Parte do Grupo FATES
                    </Typography>
                    <Typography variant='body2' color='text.secondary' className={description}>
                    M A SERVIÇOS DE USINAGEM LTDA, faz parte do Grupo FATES, sendo uma fabrica independente, 
                    que atua de forma autonoma no seguimento de prestação de serviços de usinagem, 
                    oferecendo a ela um vasto conhecimento técnico de decadas de desenvolvimento e fabricação 
                    de maquinas de alta performance/durabilidade, o qual qualificou nossa equipe, fornecendo 
                    um vasto know-how em usinagem nos mais variados tipos de peças e materiais.
                    <br />
                    <br />
                    A M A oferece através do seu parque fabril a mais completa linha de opçoes de usinagem, a 
                    qual vai desde peças de pequeno até medio porte, podendo ser unitárias ou seriadas em máquinas 
                    convencionais ou CNC. Consulte-nos.
                    </Typography>
                </Container>
            </Container>
        </Container>
    )
}